import type { Scope, SeverityLevel } from '@sentry/react';

import { configureSentry, configureSentrySync } from './sentry';

export const TAG_FIREBASE_SENTRY: [string, string] = ['service', 'firebase'];

export const setTag = (scope: Scope) => {
  scope.setTag(...TAG_FIREBASE_SENTRY);
};

export const configureFirebaseSentry = (severity?: SeverityLevel) => {
  const { withSentry, scope } = configureSentry(severity);
  setTag(scope);
  return withSentry;
};

export const configureFirebaseSentrySync = (severity?: SeverityLevel) => {
  const { withSentry, scope } = configureSentrySync(severity);
  setTag(scope);
  return withSentry;
};

export const withFirebaseErrorSentry = configureFirebaseSentry('error');
export const withFirebaseWarningSentry = configureFirebaseSentry('warning');
